__turbopack_context__.v({
  "ArtistCard": "MXH7Ga_ArtistCard",
  "ArtistCard--IsLoading": "MXH7Ga_ArtistCard--IsLoading",
  "ArtistCard__AboutText": "MXH7Ga_ArtistCard__AboutText",
  "ArtistCard__AboutWrapper": "MXH7Ga_ArtistCard__AboutWrapper",
  "ArtistCard__AssociatedActs": "MXH7Ga_ArtistCard__AssociatedActs",
  "ArtistCard__AssociatedActsWrap": "MXH7Ga_ArtistCard__AssociatedActsWrap",
  "ArtistCard__BottomWrapper": "MXH7Ga_ArtistCard__BottomWrapper",
  "ArtistCard__Container": "MXH7Ga_ArtistCard__Container",
  "ArtistCard__Content": "MXH7Ga_ArtistCard__Content",
  "ArtistCard__ImageWrapper": "MXH7Ga_ArtistCard__ImageWrapper",
  "ArtistCard__InfoWrapper": "MXH7Ga_ArtistCard__InfoWrapper",
  "ArtistCard__Tag": "MXH7Ga_ArtistCard__Tag",
  "ArtistCard__TagList": "MXH7Ga_ArtistCard__TagList",
  "ArtistCard__TagListPlaceholder": "MXH7Ga_ArtistCard__TagListPlaceholder",
  "ArtistCard__Title": "MXH7Ga_ArtistCard__Title",
  "shine": "MXH7Ga_shine",
});
